export const theme = {
  colors: {
    black: '#000000',
    lightGray: '#d4d4d4',
    white: '#ffffff',
    gray: '#d8d3d3',
    darkGray: '#6b6b6b',
    blue: '#2196f3',
  },
};
